<template>
  <div class="page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >账号注销
    </navigation>
    <div class="content-container">
      <div class="content">
        <div class="title">特别提示</div>
        <div class="sub-title">天美贷平台账户一经注销不可恢复</div>
        <div>1. 一经注销，您将无法再登录、使用天美贷账户</div>
        <div>2. 本账户关联身份实名等信息将无法有效使用</div>
      </div>
      <div class="content section2">
        <div class="title">注销须知</div>
        <div class="sub-title">若您仍选择注销账户，您的账户需同时满足以下条件</div>
        <div>1. 账户内无未完成的订单和服务</div>
        <div>2. 账户内无未结清的订单</div>
        <div>3. 账户当前为有效账户</div>
      </div>
    </div>
    <nd-button @click="continueSignout">已知悉风险，继续注销</nd-button>
    <!-- 账号注销挽留弹窗（有额度/无额度）已下线 -->
    <!-- <signout-amount-pop
      v-model="signoutAmountPopVisible"
      :creditAmountInfo="creditAmountInfo"
    />
    <signout-noAmount-pop
      v-model="signoutNoAmountPopVisible"
      :amountLimit="creditLimit"
    /> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  // 账号注销挽留弹窗（有额度/无额度）已下线
  // components: {
  //   'signout-amount-pop': () => import('./components/signout-amount-pop.vue'),
  //   'signout-noAmount-pop': () => import('./components/signout-noAmount-pop.vue')
  // },
  async created () {
    this.$bus.$emit('ready')
  },
  // 弹窗已下线，进入本页不再拉取额度信息
  // async mounted () {
  //   await this.getCreditLimitInfo()
  // },
  // data () {
  //   return {
  //     signoutAmountPopVisible: false, // 用户有有效额度
  //     creditAmountInfo: {},
  //     signoutNoAmountPopVisible: false // 用户无有效额度
  //   }
  // },
  // computed: {
  //   ...mapState('user', {
  //     creditStatus: state => state.quotaInfo.creditStatus,
  //     creditLimit: state => state.quotaInfo.creditLimit || 0
  //   })
  // },
  methods: {
    ...mapActions('user', ['getCanCancelStatus']),
    async continueSignout () {
      const { success, data } = await this.getCanCancelStatus()
      if (success && data.canCancel === 'Y') {
        this.$router.push({
          path: '/mine/signout/auth-notice'
        })
      } else {
        // 无法注销，跳转到原因页面
        this.$router.push({
          path: '/mine/signout/reason',
          query: {
            code: data.reason || 'HAS_GOING_STATUS'
          }
        })
      }
    }
    // 账号注销挽留弹窗已下线，额度信息拉取一并移除
    // ...mapActions('withdraw', ['getLoanParameterX']),
    // async getCreditLimitInfo () {
    //   await this.getLimitX({ loanPlatform: 'TMD' })
    //   if (['CREDIT_SUCCESS', 'LOAN_INFO', 'LOAN_REFUSED'].includes(this.creditStatus)) {
    //     // 额度有效的情况下，需要获取提现参数
    //     const response = await this.getLoanParameterX({
    //       loanPlatform: 'TMD'
    //     })
    //     if (response.success && response.data) {
    //       this.creditAmountInfo = {
    //         current: response.data.creditLimit,
    //         min: response.data.productMinLimit,
    //         max: response.data.userMaxLimit
    //       }
    //       setTimeout(() => {
    //         this.signoutAmountPopVisible = true
    //       }, 300)
    //     }
    //   } else {
    //     setTimeout(() => {
    //       this.signoutNoAmountPopVisible = true
    //     }, 300)
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  width: 750px;
  height: 100%;
  background: #fafafa;
  .content-container {
    background: #fff;
    width: 100%;
    margin-top: 20px;
    .content {
      background: #fff;
      width: 100%;
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 28px;
      color: #666;
      line-height: 48px;
      padding: 50px 40px;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
        line-height: 50px;
      }
      .sub-title {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333;
      }
    }
    .section2 {
      padding: 30px 40px 50px;
    }
  }
  .nd-button {
    margin: 120px auto;
  }
}
</style>